import { render } from "./SourcesOverlay.vue?vue&type=template&id=0b81fe58&scoped=true"
import script from "./SourcesOverlay.vue?vue&type=script&lang=js"
export * from "./SourcesOverlay.vue?vue&type=script&lang=js"

import "./SourcesOverlay.vue?vue&type=style&index=0&id=0b81fe58&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b81fe58"]])

export default __exports__